// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { DnaSyngoviaConnectionRect } from '../../interfaces/dna-syngovia-connection-rect';
import { DnaSyngoviaGroupNodeEType } from '../../interfaces/dna-syngovia-group-node';
import { AbstractChartMapService } from './abstract-chart-map.service';

@Injectable({
  providedIn: 'root',
})
export class DigitalProductChartMapSevice extends AbstractChartMapService {
  public override calculateRectValues(
    rects: DnaSyngoviaConnectionRect[],
    row = 0,
    column = 0,
  ): {
    row: number;
    column: number;
  } | void {
    rects.forEach((rect) => {
      const type = rect.connection.groupNode.type;

      const widthPadding = this.getWidthPadding(type);
      const modalityWidthPadding = this.getWidthPadding(
        DnaSyngoviaGroupNodeEType.MODALITY,
      );

      const serverWidthPadding = this.getWidthPadding(
        DnaSyngoviaGroupNodeEType.SERVER,
      );

      const x =
        column * widthPadding +
        this.NUM_OF_COLUMNS * modalityWidthPadding +
        serverWidthPadding;
      const y = this.heightByRow(row, type);

      rect.rect = this.createDOMRectInstance(x, y, type);
      rect.linePath = this.calculateLinePath(rect, row, column);

      column++;
      if (column > this.NUM_OF_COLUMNS - 1) {
        column = 0;
        row++;
      }
    });

    if (
      column <= this.NUM_OF_COLUMNS - 1 &&
      rects.length % this.NUM_OF_COLUMNS !== 0
    ) {
      row++;
    }

    return { row, column };
  }

  protected override calculateLinePath(
    rect: DnaSyngoviaConnectionRect,
    row: number,
    column: number,
  ): string | null {
    const { x, y, width, height } = rect.rect;
    const entrySegment = this.ENTRY_SEGMENT_SMALL;

    const rowFactor = (row + 1) % 2;

    const linePath =
      `M ${x + width * 0.5} ${y + height * rowFactor}` +
      ` l 0 ${entrySegment * (rowFactor ? 1 : -1)}` +
      ` l ${-(width * (column + 0.5) + this.PADDING * (column + 1))} 0`;

    return linePath;
  }
}
